export const PREMATURE = { id: 'premature', label: 'Rottura prematura membrane' };
export const PROLONGED = { id: 'prolonged', label: 'Gravidanza protratta' };
export const OLIGOHYDRAMNIOS = { id: 'oligohydramnios', label: 'Oligoidramnios' };
export const MATERNAL_PATHOLOGY = { id: 'maternal_pathology', label: 'Patologia materna' };
export const FETAL_PATHOLOGY = { id: 'fetal_pathology', label: 'Patologia fetale' };
